import { isFunction } from 'underscore';

/**
 * Event.stopPropagation is used to stop propagating React syntheticEvent.
 * Say, if a child element uses Event.stopPropagation, the parent node won't handle this event.
 *
 * Event.nativeEvent.stopImmediatePropagation is used to stop propagating current event to
 * other handlers that also bound on same element.
 * Like we bind two event handlers in document node and both deal with "click" event,
 * if the first one uses stopImmediatePropagation, the second one won't execute.
 * @param {Object} event Event
 * @param {Boolean} stopReactSyntheticEvent Stop propagate React Synthetic event
 * @param {Boolean} stopNativeSiblingEvent Stop propagate event to other event handlers
 * bound on same node.
 * @returns {Undefined} Do nothing.
 */
export const preventEventPropagation = (
  event,
  stopReactSyntheticEvent = true,
  stopNativeSiblingEvent = true
) => {
  if (stopReactSyntheticEvent && isFunction(event.stopPropagation)) {
    event.stopPropagation();
  }
  if (stopNativeSiblingEvent && event.nativeEvent
    && isFunction(event.nativeEvent.stopImmediatePropagation)) {
    event.nativeEvent.stopImmediatePropagation();
  }
};
